import { render, staticRenderFns } from "./ViewerSidePanel.vue?vue&type=template&id=20198c16&scoped=true"
import script from "./ViewerSidePanel.vue?vue&type=script&lang=js"
export * from "./ViewerSidePanel.vue?vue&type=script&lang=js"
import style0 from "./ViewerSidePanel.vue?vue&type=style&index=0&id=20198c16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20198c16",
  null
  
)

export default component.exports